export default __webpack_public_path__ + "static/media/durafan.c8119e43.jpeg";